import { DefaultTeamLogo, useCurrencyNetworks } from '@capsicum/common';

import { usePartners } from '../../partners';

import type { ApproveTransactionModalProps } from '../models';

export const useApproveTransactionModal = (payload: ApproveTransactionModalProps['payload']) => {
	const { getPartnerBy } = usePartners();
	const { currencyNetwork, isLoadingCurrencyNetworks } = useCurrencyNetworks({
		smartContractAddresses: payload.to ? [payload.to] : []
	});
	// TODO: The currency image just works with partners for now
	const currencyNetworkImage = currencyNetwork
		? getPartnerBy(p => p.shortName === currencyNetwork?.currency?.shortCode)?.images?.partnerLogo?.url
		: DefaultTeamLogo;

	return {
		currencyNetwork,
		currencyNetworkImage,
		isLoadingCurrencyNetworks
	};
};
